export default {
      id: "about-2-usage",
      viewBox: "0 0 50 50",
      url: "/" + "assets/sprite.svg#about-2",
      toString: function () {
        return this.url;
      }
    }